import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

/* replace-start */
import './index.less';
/* replace-end */
class Feature22 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div
          {...dataSource.img}
        >
          <img src={dataSource.img.children} width="100%" alt="img" />
        </div>
      </OverPack>
    );
  }
}
export default Feature22;
